var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"popup-close",on:{"click":function($event){return _vm.closePopup()}}},[_c('img',{attrs:{"src":require("@/assets/img/close-2.svg"),"alt":""}})]),_vm._t("default")],2),_c('div',{staticClass:"blur"})])
}
var staticRenderFns = []

export { render, staticRenderFns }